const TYPOGRAPHY_TITLES = {
  h1: { text: "Heading (H1)" },
  h2: { text: "Sub Header (H2)" },
  h3: { text: "Sub Header (H3)" },
  h4: { text: "Sub Header (H4)" },
  p1: { text: "Body (P1)" },
  p2: { text: "Body - Small (P2)" },
  p3: { text: "Secondary (P3)" },
  p4: { text: "Small (P4)" }
};

export default TYPOGRAPHY_TITLES;



// WEBPACK FOOTER //
// ./catalog/pages/typography/titles.js